"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _SubMenuItem = require("./SubMenuItem.styles");
var _mapIconKeyToUiKit = _interopRequireDefault(require("../../utils/mapIconKeyToUiKit"));
var _SubMenu = require("../Nav/Desktop/SubMenu/SubMenu.style");
var _Text = _interopRequireDefault(require("../Text/Text.render"));
const SubMenuItemRender = _ref => {
  let {
    text,
    icon,
    showing,
    openModal,
    code,
    type,
    customItemWidth,
    metadata
  } = _ref;
  const open = () => {
    if (!code || !metadata) return;
    openModal({
      code,
      metadata
    });
  };
  return /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItemInner, {
    showing: showing,
    customItemWidth: customItemWidth,
    onClick: type === 'SalesForce' ? open : undefined
  }, /*#__PURE__*/_react.default.createElement(_SubMenuItem.TextContainer, null, /*#__PURE__*/_react.default.createElement(_SubMenuItem.ItemTextWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    variant: "Primary",
    intlText: text
  })), icon && /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: (0, _mapIconKeyToUiKit.default)(icon),
    size: "1x",
    color: _uiKit.theme.colours.PRIMARY_1
  })));
};
var _default = exports.default = SubMenuItemRender;